import { ReactComponent as autoStoriesIcon } from '../../../../../../icons/auto_stories.svg';
import React, { useContext, useEffect, useState } from "react";
import './addPublicationProposalModal.scss';
import { apiContext } from '../../../../../../contexts/apiContext';
import { ButtonFieldProps } from '../../../../../../components/buttonField/types/buttonFieldProps';
import { classNameBtn } from '../../../../../../components/shared/button/types/buttonProps';
import { stylizationVerticalAlign } from '../../../../../../components/shared/stylization';
import { FormFieldProps } from '../../../../../../components/formField/types/formFieldProps';
import { notifyError, notifySuccess } from '../../../../../../components/snackbar/snackbar';
import ButtonField from '../../../../../../components/buttonField/buttonField';
import Modal from '../../../../../../components/modalWindow/modal';
import FormField from '../../../../../../components/formField/formField';
import KrFormContext, { PublicationsAttributes } from '../../../../../../contexts/krFormContext';
import { AddPublicationProposalModalProps } from './types/addPublicationProposalModalProps';
import { addPublicationDictProposal } from '../../../../../../services/dictionariesService/dictionariesService';
import { AddPublicationDictProposalProps } from '../../../../../../services/dictionariesService/types/dictionariesServiceProps';
import { configValidation, createConfigValidation } from "../../../../../../helpers/validation/validation";
import { setDictProposition } from '../../../../../../database/indexedDbReadWrite';
import AuthContext from '../../../../../../contexts/authContext';
import SelectInput from '../../../../../../components/shared/selectInput/selectInput';
import { prepareDataSingleForSelect } from '../../../../../../helpers/prepareForSelect';
import { Option } from "../../../../../../components/shared/selectInput/types/selectInputProps";

const AddPublicationProposalModal = (props: AddPublicationProposalModalProps) => {
    const api = useContext(apiContext);
    const { local } = useContext(KrFormContext);
    const { username, onlineMode } = useContext(AuthContext);
    const [newPublication, setNewPublication] = useState<PublicationsAttributes>({});
    const [checkValidationFlag, setCheckValidationFlag] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    const [reloadWydawnictwo, setReloadWydawnictwo] = useState<boolean>(false);
    const [reloadOznaczenie, setReloadOznaczenie] = useState<boolean>(false);
    const [czasopismoConfig, setCzasopismoConfig] = useState<configValidation>(createConfigValidation("czasopismO_NAZWA", undefined, newPublication.wydawnictwO_NAZWA));
    const [wydawnictwoConfig, setWydawnictwoConfig] = useState<configValidation>(createConfigValidation("wydawnictwO_NAZWA", undefined, newPublication.czasopismO_NAZWA));
    const [oznaczenieConfig, setOznaczenieConfig] = useState<configValidation>(createConfigValidation("czasopismO_OZNACZENIE", undefined, newPublication.czasopismO_NAZWA));
    const [typPublikacji, setTypPublikacji] = useState<configValidation>(createConfigValidation("onlyRequired"));

    // Inputs   
    const getInputProps = (labelName: string, inputPlaceholder: string, inputId: string, type: string, value?: string | number | null, configValidation?: configValidation): FormFieldProps => {
        return {
            labelName: labelName,
            inputPlaceholder: inputPlaceholder,
            type: type,
            pristine: true,
            setValue: (event: any) => onChangeInput(event, inputId),
            style: {
                paddingTop: "10px"
            },
            className: "empty",
            value: value === null ? "" : value,
            configValidation: configValidation,
            validationError: checkValidationFlag,
            disabled: loading
        };
    }

    useEffect(() => {
        setReloadWydawnictwo(!reloadWydawnictwo);
        setWydawnictwoConfig(createConfigValidation("wydawnictwO_NAZWA", undefined, newPublication.czasopismO_NAZWA));
        setOznaczenieConfig(createConfigValidation("czasopismO_OZNACZENIE", undefined, newPublication.czasopismO_NAZWA));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newPublication.czasopismO_NAZWA])

    useEffect(() => {
        setReload(!reload);
        setCzasopismoConfig(createConfigValidation("czasopismO_NAZWA", undefined, newPublication.wydawnictwO_NAZWA));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newPublication.wydawnictwO_NAZWA])

    useEffect(() => {
        setTypPublikacji(createConfigValidation("onlyRequired"));
    }, [newPublication.tyP_PUBLIKACJI_SID])

    const onChangeInput = (event: any, id: any) => {  
        setNewPublication((prevData) => ({...prevData, [id]: event}));
    }

    const onChangeSelect = (opt: Option[]) => {  
        setNewPublication((prevData) => ({...prevData, tyP_PUBLIKACJI_SID: opt.length > 0 ? opt[0].value as number : undefined}));
    }

    // 'Add proposal' button
    const getBtnProps = (title: string, btnClass: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${btnClass} body-txt-medium`,
                style: {
                    marginRight: "10px"
                }
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
        };
    }

    const checkValidation = () => {
        setCheckValidationFlag(true);
        setReload(!reload);
        setReloadOznaczenie(!reloadOznaczenie);
        setReloadWydawnictwo(!reloadWydawnictwo);
        if (newPublication.autorzy === undefined || newPublication.autorzy === null || newPublication.autorzy === "") return false;
        if (newPublication.publikacjA_SOPO === undefined || newPublication.publikacjA_SOPO === null || newPublication.publikacjA_SOPO === "") return false;
        if (newPublication.roK_POWSTANIA === undefined || newPublication.roK_POWSTANIA === null) return false;
        if ((newPublication.wydawnictwO_NAZWA === undefined || newPublication.wydawnictwO_NAZWA === null || newPublication.wydawnictwO_NAZWA === "") && 
        (newPublication.czasopismO_NAZWA === undefined || newPublication.czasopismO_NAZWA === null || newPublication.czasopismO_NAZWA === "")) {  
            return false;
        }
        if((newPublication.czasopismO_NAZWA !== undefined && newPublication.czasopismO_NAZWA !== null && newPublication.czasopismO_NAZWA !== "") &&
            (newPublication.czasopismO_OZNACZENIE === null || newPublication.czasopismO_OZNACZENIE === undefined || newPublication.czasopismO_OZNACZENIE === "")){
                return false;
            }

        return true;
    }

    const handleAddPublicationProposal = () => {
        if (checkValidation()) {
            let addPublicationProposalProps: AddPublicationDictProposalProps = {
                newPublication: newPublication,
                apiBase: api.apiUrl + api.apiVersion
            }
            
            setLoading(true);
            if (local && !onlineMode) {
                setDictProposition(username, addPublicationProposalProps, "publication").then((response) => {
                    notifySuccess({ message: "Dodano propozycję publikacji, propozycja zostanie zsynchronizowana po przejściu na tryb online" });
                    close();
                }).catch(() => {
                    notifyError({ message: "Dodanie propozycji publikacji zakończone niepowodzeniem" });
                }).finally(() => {
                    setLoading(false);
                });
            }
            else{
                addPublicationDictProposal(addPublicationProposalProps)
                .then(() => {   
                    notifySuccess({ message: "Dodano propozycję publikacji" });    
                    close();
                })
                .catch(() => {
                    notifyError({ message: "Dodanie propozycji publikacji zakończone niepowodzeniem" });               
                })
                .finally(() => {
                    setLoading(false);
                });  
            }
        }           
    }

    const close = () => {
        props.onClose();
        refocus();
    }
    
    const refocus = () => {
        if (props.refocus) props.refocus();
    }

    const actionBtns = [
        <ButtonField key={1}{...getBtnProps("Anuluj", classNameBtn.LargeSecondary, () => { close() })}></ButtonField>,
        <ButtonField key={2}{...getBtnProps("Wyślij propozycję publikacji", classNameBtn.Large, () => { handleAddPublicationProposal() })}></ButtonField>
    ]

    const TypPublikacji = () => {
        return (
            <SelectInput 
                        placeHolder="Wybierz typ publikacji"  
                        label="Typ publikacji"
                        hasInputTags={true} 
                        options={props.publicationsDict} 
                        onlySingleTag={true}
                        style={{ paddingTop: "10px", width: "95.5%", textAlign: 'left' }}
                        selectedOptions={prepareDataSingleForSelect(props.publicationsDict, [newPublication.tyP_PUBLIKACJI_SID])}
                        onChange={onChangeSelect} 
                        pristine={true}
                        disabled={false}
                        configValidation={typPublikacji}
                        validationError={checkValidationFlag} />
        )
    }

    return (<Modal
        title={"Publikacje"}
        titleIcon={autoStoriesIcon}
        iconClass='titleIcon'
        width={'1100px'}
        height={'605px'}
        actionBtns={actionBtns}
        onClose={close}
        loading={loading}> 
        <div className='addPublicationProposalModalWrapperOuter'>
            <FormField {...getInputProps("Publikacja", "Wpisz tytuł publikacji", "publikacjA_SOPO", "text", newPublication.publikacjA_SOPO, createConfigValidation("onlyRequired"))}/>
            <div className='addPublicationProposalModalWrapperInner'>                        
                <div>
                    <FormField {...getInputProps("Autorzy", "Wpisz pełne nazwiska i imiona autorów, np. Kowalski Jan, Kowalska Anna", "autorzy", "text", newPublication.autorzy, createConfigValidation("onlyRequired"))}/>  
                    {reload ? <FormField {...getInputProps("Nazwa czasopisma", "Wpisz nazwę czasopisma", "czasopismO_NAZWA", "text", 
                    newPublication.czasopismO_NAZWA, czasopismoConfig)}/> :
                    <><FormField {...getInputProps("Nazwa czasopisma", "Wpisz nazwę czasopisma", "czasopismO_NAZWA", "text", 
                    newPublication.czasopismO_NAZWA, czasopismoConfig)}/></>}
                    {reloadOznaczenie ? <FormField {...getInputProps("Oznaczenie czasopisma", "Wpisz oznaczenie czasopisma (tom, numer, zeszyt, wolumin itp.)", "czasopismO_OZNACZENIE", "text", 
                    newPublication.czasopismO_OZNACZENIE, oznaczenieConfig)}/> : 
                    <><FormField {...getInputProps("Oznaczenie czasopisma", "Wpisz oznaczenie czasopisma (tom, numer, zeszyt, wolumin itp.)", "czasopismO_OZNACZENIE", "text", 
                    newPublication.czasopismO_OZNACZENIE, oznaczenieConfig)}/></>}
                </div>     
                <div>
                    <FormField {...getInputProps("Rok powstania", "Wpisz rok powstania publikacji", "roK_POWSTANIA", "number", newPublication.roK_POWSTANIA, createConfigValidation("onlyRequired"))} onlyDigits={true}/>
                    {reloadWydawnictwo ? <FormField {...getInputProps("Nazwa wydawnictwa", "Wpisz nazwę wydawnictwa", "wydawnictwO_NAZWA", "text", 
                    newPublication.wydawnictwO_NAZWA, 
                    wydawnictwoConfig )}/>  : 
                    <><FormField {...getInputProps("Nazwa wydawnictwa", "Wpisz nazwę wydawnictwa", "wydawnictwO_NAZWA", "text", 
                    newPublication.wydawnictwO_NAZWA, 
                    wydawnictwoConfig )}/></> }  
                    {reload ? TypPublikacji() : <>{TypPublikacji()}</>}          
                </div>      
            </div> 
        </div>     
    </Modal>);
};

export default AddPublicationProposalModal;